import "react-app-polyfill/ie11"
import "react-app-polyfill/stable"

import React from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from '@material-ui/styles'
// import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { MembershipFormProvider } from './context/membership'
import Header from './components/header'
import Footer from './components/footer'
import Loading from './components/loading'

import theme from './theme'

document.addEventListener('keydown', function(e) {
  if (e.key === 'Tab') {
    document.body.classList.add('show-focus-outlines');
  }
});

document.addEventListener('click', function(e) {
  document.body.classList.remove('show-focus-outlines');
});

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <React.Fragment>
    <MembershipFormProvider>
      <ThemeProvider theme={theme}>
        <Header />
        <App />
        <Footer />
        <Loading />
      </ThemeProvider>
    </MembershipFormProvider>
  </React.Fragment>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();